/* eslint-disable react/no-danger */
import React from 'react';
import moment from 'moment';
import { Button } from 'antd';
import { api } from '@unicus/react-ui-kit';
import { DownloadOutlined } from '@ant-design/icons';
import HtmlEditor from 'components/HtmlEditor/HtmlEditor';
import { MEMED, RECEITADIGITAL } from 'constants/types';

const SectionFieldPrescription = ({
  id,
  creationTime,
  lastModificationTime,
  prescription = {}
}) => {
  const { name, text, source, receitaDigital } = prescription ?? {};

  const handleDownload = () => {
    if (source === RECEITADIGITAL && receitaDigital) {
      const { urlFromPdf } = receitaDigital;
      window.open(urlFromPdf);
      return;
    }

    window.open(
      api.getUrlFromResource(`attendances/${prescription.id}/prescription-pdf`)
    );
  };

  return (
    <div className="gx-mt-4">
      <div className="gx-fs-lg gx-font-weight-bold gx-mb-1">{name}</div>
      <div className="gx-fs-11">
        {moment(creationTime).format('[Criado em] DD/MM/YYYY HH:mm')}
      </div>
      {lastModificationTime ? (
        <div className="gx-fs-11">
          {moment(lastModificationTime).format(
            '[Atualizado em] DD/MM/YYYY HH:mm'
          )}
        </div>
      ) : null}
      <div dangerouslySetInnerHTML={{ __html: text }} />
      <div className="gx-mt-2">
        <Button
          size="small"
          icon={<DownloadOutlined />}
          onClick={handleDownload}
          id="teste-memed"
        >
          Imprimir
        </Button>
      </div>
    </div>
  );
};

export default SectionFieldPrescription;
